import { render, staticRenderFns } from "./SelectAsientosBloqueadosComponent.vue?vue&type=template&id=20848160"
import script from "./SelectAsientosBloqueadosComponent.vue?vue&type=script&lang=js"
export * from "./SelectAsientosBloqueadosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports